import { useEffect, useRef, useState } from 'react';

export const useCheckContentScrollEffect = (isOpen?: boolean) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [hasScroll, setHasScroll] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (contentRef.current) {
        const { scrollHeight, clientHeight } = contentRef.current;
        const hasOverflow = scrollHeight > clientHeight;
        setHasScroll(
          hasOverflow &&
            contentRef.current.scrollTop < scrollHeight - clientHeight - 1,
        );
      }
    };

    const contentElement = contentRef.current;
    if (contentElement) {
      checkScroll();
      contentElement.addEventListener('scroll', checkScroll);
      window.addEventListener('resize', checkScroll);
    }

    return () => {
      if (contentElement) {
        contentElement.removeEventListener('scroll', checkScroll);
      }
      window.removeEventListener('resize', checkScroll);
    };
  }, [isOpen]);

  return { contentRef, hasScroll };
};
